import { StyledButton } from "@aureskonnect/react-ui";
import { isCatalogueDisplayMode } from "@constants";
import { t } from "i18next";
import { useSnapshot } from "valtio";

import React from "react";
import Modal from "react-modal";

import { store } from "@store";

import { getEntityData } from "@helpers/general";

import { FlexboxGrid } from "@components/common/FlexboxGrid";
import { SpinnerWrapper } from "@components/common/SpinnerWrapper";
import { EntitySelection } from "@components/Synchronization/EntitySelectionModalWrapper/EntitySelection";
import { Header } from "@components/Synchronization/Header";
import {
    setFranchiseSchema,
    setIsEntitySelectionModalOpened,
    setIsSubRowEntityClicked,
    setSelectedEntity,
    setSelectedEntityChild,
    setSelectedEntityChildren,
    setUidConnectedUser,
    syncStore,
} from "@components/Synchronization/store";

import { kioskStore, setIsAuthenticationModalOpened } from "@pages/Kiosk/store";

import { EntityChildrenSelection } from "../EntityChildrenSelectionModalWrapper/EntityChildrenSelection";
import "./index.css";

export function EntitySelectionModalWrapper(): JSX.Element {
    const { middlewareApiUrl } = useSnapshot(store);

    const {
        isEntitySelectionModalOpened,
        connectedUserEntity,
        uidConnectedUser,
        isSubRowEntityClicked,
    } = useSnapshot(syncStore);
    const { isLocalConfigModalOpened } = useSnapshot(kioskStore);

    const [
        isEntityChildrenSelectionModalOpened,
        setIsEntityChildrenSelectionModalOpened,
    ] = React.useState(false);
    const [data, setData] = React.useState<EntityType[]>([]);
    const [isLoading, setIsLoading] = React.useState(false);

    async function getEntity() {
        setIsLoading(true);
        const url = `${middlewareApiUrl}/getEntityKioskV1/${
            data && data.length > 0
                ? data[0].franchiseUuid
                : connectedUserEntity
        }/${uidConnectedUser}`;
        return (
            fetch(url)
                .then((response) => response.json())
                // eslint-disable-next-line
                .then(async (response) => {
                    const entities = getEntityData(response.data);
                    setData(entities);
                    if (response.data.length === 1) {
                        setSelectedEntity(entities[0]);
                        setFranchiseSchema(entities[0].franchise);
                        setSelectedEntityChildren(
                            entities[0].children as EntityType[]
                        );
                    }
                })
                .catch((error) => {
                    console.log(
                        `Error during the validation of change machine transaction, with the message ${error}`
                    );
                })
                .finally(() => {
                    setIsLoading(false);
                })
        );
    }
    function handleGoBackButtonOnClickEvent() {
        if (isEntityChildrenSelectionModalOpened) {
            setIsEntityChildrenSelectionModalOpened(false);
            if (!isLocalConfigModalOpened) {
                setSelectedEntityChild(undefined);
            }
        } else if (
            data.filter(
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                (entity: any) => entity.uid === connectedUserEntity
            ).length > 0 ||
            (!isSubRowEntityClicked &&
                data.filter(
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    (entity: any) => entity.uid === connectedUserEntity
                ).length === 0 &&
                data.filter(
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    (entity: any) => entity.children.length === 0
                ).length > 0)
        ) {
            if (!isLocalConfigModalOpened) {
                setIsAuthenticationModalOpened(true);
                setSelectedEntityChild(undefined);
                setUidConnectedUser("");
            }
            setIsEntitySelectionModalOpened(false);
            setSelectedEntity(undefined);
            setSelectedEntityChildren([]);
            setIsSubRowEntityClicked(false);
        } else {
            getEntity();
        }
    }

    React.useEffect(() => {
        if (!isLocalConfigModalOpened) {
            localStorage.removeItem("selectedShopApp");
            localStorage.removeItem("selectedEntityChild");
        }
        getEntity();
    }, []);

    return (
        <Modal
            isOpen={isEntitySelectionModalOpened}
            ariaHideApp={false}
            style={{
                overlay: {
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    backgroundColor: "transparent",
                    zIndex: 2,
                },
                content: {
                    display: "flex",
                    flexDirection: "column",
                    padding: "0px",
                    color: "black",
                    height: "1366px",
                    width: "914px",
                    overflow: "unset",
                    zIndex: 2,
                    backgroundColor: "#FFFFFF",
                    borderLeft: "1px solid #707070",
                    borderRight: "1px solid #707070",
                    borderBottom: "1px solid #707070",
                    borderTop: "15px",
                    borderRadius: "20px",
                    bottom: "unset",
                    top: "unset",
                    right: "unset",
                    left: "unset",
                    zoom: `${isCatalogueDisplayMode() ? "50%" : "100%"}`,
                },
            }}
        >
            <Header />
            <FlexboxGrid className="h-100 flex-column justify-content-between">
                {isLoading ? (
                    <SpinnerWrapper />
                ) : isEntityChildrenSelectionModalOpened ? (
                    <EntityChildrenSelection />
                ) : (
                    <EntitySelection
                        setData={setData}
                        data={data}
                        setIsEntityChildrenSelectionModalOpened={
                            setIsEntityChildrenSelectionModalOpened
                        }
                        isLoading={isLoading}
                    />
                )}
            </FlexboxGrid>
            <FlexboxGrid
                className="flex-column"
                alignItemsCentered={true}
                justifyContentCentered={true}
                gap="10px"
                styles={{
                    background:
                        "linear-gradient(135deg, #1f2937 0%, #111827 100%)",
                    borderRadius: "0px 0px 20px 20px",
                }}
            >
                <FlexboxGrid
                    alignItemsCentered={true}
                    justifyContentCentered={true}
                    className="w-100"
                    styles={{
                        boxShadow: "0px 3px 6px #00000029",
                        border: "1px solid #FFFFFF",
                        borderRadius: "0px 0px 20px 20px",
                    }}
                >
                    <StyledButton
                        rounded={true}
                        className="text-uppercase m-2"
                        style={{
                            width: "180px",
                            height: "60px",
                            fontSize: "var(--font-size-base)",
                            fontWeight: "500",
                            borderRadius: "12px",
                            backgroundColor: "#ffffff",
                            border: "2px solid #e5e7eb",
                            color: "#374151",
                            transition: "all 0.2s ease",
                        }}
                        onClick={handleGoBackButtonOnClickEvent}
                    >
                        {isEntityChildrenSelectionModalOpened
                            ? t("Back")
                            : data.filter(
                                  // eslint-disable-next-line @typescript-eslint/no-explicit-any
                                  (entity: any) =>
                                      entity.uid === connectedUserEntity
                              ).length > 0 ||
                              (!isSubRowEntityClicked &&
                                  data.filter(
                                      // eslint-disable-next-line @typescript-eslint/no-explicit-any
                                      (entity: any) =>
                                          entity.uid === connectedUserEntity
                                  ).length === 0 &&
                                  data.filter(
                                      // eslint-disable-next-line @typescript-eslint/no-explicit-any
                                      (entity: any) =>
                                          entity.children.length === 0
                                  ).length > 0)
                            ? t("Sign out")
                            : t("Back")}
                    </StyledButton>
                </FlexboxGrid>
            </FlexboxGrid>
        </Modal>
    );
}
